export default __webpack_public_path__ + "static/media/background-login-sm.35c73a9a.png";